import { AxiosMULEEX, orgId } from "../apiConfig";
import { appendQueryParams } from "../../utilities/urlUtils";

export const locationAndTaxApiFactory = {
  $_getAll3plLocations(params) {
    let url = `/location/get-all-location/${orgId()}${appendQueryParams(params)}`;
    return AxiosMULEEX.get(url);
  },
  $_getSingleLocationDetails(locationId) {
    let url = `/location/view-location/${locationId}`;
    return AxiosMULEEX.get(url);
  },
  $_createLocation(payload) {
    let url = `/location/create-location`;
    // payload.orgId = orgId();
    return AxiosMULEEX.post(url, payload);
  },

  $_getAllTax() {
    let url = `/tax/all/${orgId()}`;
    return AxiosMULEEX.get(url);
  },

  $_update3plLocation(payload) {
    let url = `/location/update-location/${orgId()}/${payload.id}/`;
    return AxiosMULEEX.patch(url, payload);
  },
  $_delete3plLocation(locationId) {
    let url = `/location/delete-location/${locationId}`;
    return AxiosMULEEX.delete(url);
  },

  $_createTax(payload) {
    let url = `/tax/create`;
    return AxiosMULEEX.post(url, { payload: payload });
  },

  $_deleteTax(taxId) {
    let url = `/tax/delete/${taxId}`;
    return AxiosMULEEX.delete(url);
  },

  $_updateTax(payload) {
    let url = `/tax/update/`;
    return AxiosMULEEX.patch(url, payload);
  },

  $_getAllTaxTins() {
    let url = `/tax/get-tins/${orgId()}`;
    return AxiosMULEEX.get(url);
  },
  $_getAllTaxAuthorities() {
    let url = "/tax/get-taxAuthority";
    return AxiosMULEEX.get(url);
  },
  $_createTaxAuthorities(payload) {
    let url = "/tax/get-taxAuthority";
    return AxiosMULEEX.post(url, payload);
  },
  $_saveTin(payload) {
    let url = "/org/tax/tins";
    payload.orgId = orgId();
    return AxiosMULEEX.post(url, payload);
  },
  $_getOrgUsers(){
        let url = `/users/${orgId()}?isActive=true`;
        return AxiosMULEEX.get(url)
    }
};
